/**
 * https://dev.mysql.com/doc/refman/8.0/en/data-types.html
 */
export const MySQLTypes: string[] = [
  'BIGINT',
  'BINARY',
  'BIT',
  'BLOB',
  'BOOL',
  'BOOLEAN',
  'CHAR',
  'DATE',
  'DATETIME',
  'DEC',
  'DECIMAL',
  'DOUBLE PRECISION',
  'DOUBLE',
  'ENUM',
  'FLOAT',
  'GEOMETRY',
  'GEOMETRYCOLLECTION',
  'INT',
  'INTEGER',
  'JSON',
  'LINESTRING',
  'LONGBLOB',
  'LONGTEXT',
  'MEDIUMBLOB',
  'MEDIUMINT',
  'MEDIUMTEXT',
  'MULTILINESTRING',
  'MULTIPOINT',
  'MULTIPOLYGON',
  'NUMERIC',
  'POINT',
  'POLYGON',
  'SET',
  'SMALLINT',
  'TEXT',
  'TIME',
  'TIMESTAMP',
  'TINYBLOB',
  'TINYINT',
  'TINYTEXT',
  'VARBINARY',
  'VARCHAR',
  'YEAR',
];
